import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/core/each/each.js";
import "dabbyjs/src/events/on/on.js";

// Function to stop videos if the hub popup containing it is closed
export default obj => {
	if (obj.length) {
		$(".hub__switch").on("change", () => {
			obj.each(function () {
				this.pause();
			});
		});
	}
};